export const SEARCH_BY_TERM = 'SEARCH_BY_TERM';
export const SEARCH_BY_CITY_STATE = 'SEARCH_BY_CITY_STATE';
export const SEARCH_BY_LAT_LONG = 'SEARCH_BY_LAT_LONG';
